export const sharedCommonDe = {
  "Close": "schließen",
  "PDF optimal zoom": "optimal",
} as const;

export const sharedCommonEn = {
  "Close": "Close",
  "PDF optimal zoom": "fit",
} as const;

export const sharedCommonTranslations = {
  de: sharedCommonDe,
  en: sharedCommonEn,
} as const;

export type SharedCommonLang = keyof typeof sharedCommonTranslations;
export type SharedCommonKey = keyof typeof sharedCommonDe;
